exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/css-loader@0.28.11/~/css-loader?{"minimize":false,"sourceMap":false}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2abc6a98","scoped":false,"hasInlineConfig":false}!./~/.pnpm/sass-loader@7.3.1_webpack@2.7.0/~/sass-loader/dist/cjs.js?{"sourceMap":false}!./~/.pnpm/sass-resources-loader@1.3.5/~/sass-resources-loader/lib/loader.js?{"resources":"/home/runner/work/rosetta_web/rosetta_web/src/assets/style/_variables.scss"}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Setting.vue
// module id = 523
// module chunks = 1